import React from 'react';
import classes from './UltraBold.module.scss';

const UltraBold = ({children}) => {
    return (
        <div className={classes.ultrabold}>
            {children}
        </div>
    );
};

export default UltraBold;
